<template>
  <layout>
    <div slot="content">
      <i-card title="支付商户管理">
        <div slot="content">
          <div class="search-bar">
            <el-form :inline="true" :model="filter">
              <el-form-item label="商户名称">
                <el-input v-model="filter.keyword" placeholder="请输入商户名称" clearable></el-input>
              </el-form-item>
              <el-form-item label="状态">
                <el-select v-model="filter.status" placeholder="请选择" clearable>
                  <el-option label="启用" :value="1"></el-option>
                  <el-option label="禁用" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="searchList">搜索</el-button>
                <el-button @click="resetFilter">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="操作区域">
            <el-button type="primary" @click="showAddDialog">添加商户</el-button>
          </div>
          <el-table
            class="pay-merchant-table"
            :data="pageList"
            :border="true"
            style="width: 100%"
          >
            <el-table-column prop="id" label="ID" width="72" align="center"/>
            <el-table-column prop="merchant_name" label="商户名称" min-width="160" show-overflow-tooltip/>
            <el-table-column prop="merchant_key" label="商户标识" min-width="130" show-overflow-tooltip/>
            <el-table-column prop="app_id" label="AppID" min-width="180" show-overflow-tooltip/>
            <el-table-column prop="mch_id" label="商户号" min-width="120"/>
            <el-table-column label="手续费费率" width="110" align="right">
              <template slot-scope="scope">
                {{ (scope.row.cost_fee_percent * 100).toFixed(2) }}%
              </template>
            </el-table-column>
            <el-table-column label="状态" width="92" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
                  {{ scope.row.status === 1 ? '启用' : '禁用' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" min-width="170">
              <template slot-scope="scope">
                {{ scope.row.created_at | formatDateTime }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150" fixed="right">
              <template slot-scope="scope">
                <el-link size="mini" type="primary" @click="showEditDialog(scope.row)">编辑 |</el-link>
                <el-link size="mini" type="danger" @click="deleteMerchant(scope.row.id)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </i-card>
      <div class="page-wrap">
        <el-pagination background :page-size="pageInfo.per_page" :current-page="pageInfo.current_page"
                       layout="prev, pager, next" @current-change="changePage" :total="pageInfo.total"/>
      </div>
      
      <!-- 添加/编辑弹窗 -->
      <el-dialog :title="dialogTitle" :visible.sync="showDialog" width="60%">
        <el-form ref="form" :model="form" label-width="140px" :rules="rules">
          <el-form-item label="商户名称" prop="merchant_name">
            <el-input v-model="form.merchant_name" placeholder="请输入商户名称"></el-input>
          </el-form-item>
          <el-form-item label="商户标识" prop="merchant_key">
            <el-input v-model="form.merchant_key" placeholder="请输入商户标识，用于回调路由">
            </el-input>
            <div class="form-tips"><i class="el-icon-warning-outline"/> 回调地址会自动生成为：域名/api/pay/wx_pay_callback/{商户标识}</div>
          </el-form-item>
          <el-form-item label="微信AppID" prop="app_id">
            <el-input v-model="form.app_id" placeholder="请输入微信AppID"></el-input>
          </el-form-item>
          <el-form-item label="微信商户号" prop="mch_id">
            <el-input v-model="form.mch_id" placeholder="请输入微信商户号"></el-input>
          </el-form-item>
          <el-form-item label="支付密钥" prop="key">
            <el-input v-model="form.key" placeholder="请输入支付密钥" type="password" show-password></el-input>
          </el-form-item>
          <el-form-item label="支付回调地址">
            <el-input :value="`域名/api/pay/wx_pay_callback/${form.merchant_key || '{merchant_key}'}`" disabled></el-input>
            <div class="form-tips"><i class="el-icon-warning-outline"/> 回调地址由系统按商户标识自动生成，不需要手工配置</div>
          </el-form-item>
          <el-form-item label="证书文件(pem)" prop="cert_path">
            <el-upload
              class="cert-upload"
              name="cert"
              :action="uploadCertUrl"
              :data="uploadCertPostData"
              :on-success="handleCertSuccess"
              :on-error="handleCertError"
              :before-upload="beforeCertUpload"
              :show-file-list="false"
              accept=".pem,.cert"
            >
              <el-button size="small" type="primary" :loading="certUploading">
                <i class="el-icon-upload"></i> {{ form.cert_path ? '重新上传' : '上传证书' }}
              </el-button>
            </el-upload>
            <div class="form-tips" v-if="form.cert_path">
              <i class="el-icon-check" style="color: #67C23A"></i> 已上传: {{ form.cert_path }}
            </div>
            <div class="form-tips"><i class="el-icon-warning-outline"/> 请上传微信支付证书(apiclient_cert.pem)</div>
          </el-form-item>
          <el-form-item label="证书密钥文件(pem)" prop="key_path">
            <el-upload
              class="cert-upload"
              name="cert_key"
              :action="uploadCertKeyUrl"
              :data="uploadCertPostData"
              :on-success="handleCertKeySuccess"
              :on-error="handleCertKeyError"
              :before-upload="beforeCertKeyUpload"
              :show-file-list="false"
              accept=".pem,.key"
            >
              <el-button size="small" type="primary" :loading="certKeyUploading">
                <i class="el-icon-upload"></i> {{ form.key_path ? '重新上传' : '上传密钥' }}
              </el-button>
            </el-upload>
            <div class="form-tips" v-if="form.key_path">
              <i class="el-icon-check" style="color: #67C23A"></i> 已上传: {{ form.key_path }}
            </div>
            <div class="form-tips"><i class="el-icon-warning-outline"/> 请上传微信支付证书密钥(apiclient_key.pem)</div>
          </el-form-item>
          <el-form-item label="手续费费率" prop="cost_fee_percent">
            <el-input v-model.number="form.cost_fee_percent" placeholder="如: 0.006 表示0.6%"></el-input>
            <div class="form-tips"><i class="el-icon-warning-outline"/> 微信支付手续费费率，默认0.006(0.6%)</div>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="form.status">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="showDialog = false">取 消</el-button>
          <el-button type="primary" v-loading="loading" @click="submitForm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </layout>
</template>

<script>
import httpConfig from '@/api/config'

function adminApiAbsoluteUrl(apiPath) {
  const proto = httpConfig.isHttps ? 'https://' : 'http://'
  return proto + httpConfig.apiDomain + apiPath
}

export default {
  name: "pay_merchant_list",
  data() {
    return {
      pageUrl: "payMerchantList",
      pageList: [],
      pageInfo: {
        per_page: 20,
        current_page: 1,
        total: 0,
      },
      filter: {
        keyword: "",
        status: "",
      },
      loading: false,
      showDialog: false,
      dialogTitle: "添加商户",
      certUploading: false,
      certKeyUploading: false,
      form: {
        id: null,
        merchant_name: "",
        merchant_key: "",
        app_id: "",
        mch_id: "",
        key: "",
        cert_path: "",
        key_path: "",
        cost_fee_percent: 0.006,
        status: 1,
      },
      rules: {
        merchant_name: [{ required: true, message: "请输入商户名称", trigger: "blur" }],
        merchant_key: [{ required: true, message: "请输入商户标识", trigger: "blur" }],
        app_id: [{ required: true, message: "请输入微信AppID", trigger: "blur" }],
        mch_id: [{ required: true, message: "请输入微信商户号", trigger: "blur" }],
        key: [{ required: true, message: "请输入支付密钥", trigger: "blur" }],
      },
    };
  },
  computed: {
    uploadCertUrl: function () {
      return adminApiAbsoluteUrl('/api/common/upload_cert')
    },
    uploadCertKeyUrl: function () {
      return adminApiAbsoluteUrl('/api/common/upload_cert_key')
    },
    uploadCertPostData: function () {
      const data = {}
      try {
        const user = JSON.parse(localStorage.getItem('user'))
        if (user && user.api_token) {
          data.api_token = user.api_token
        }
      } catch (_e) {}
      if (this.form.mch_id && this.form.mch_id.trim()) {
        data.mch_id = this.form.mch_id.trim()
      }
      return data
    },
  },
  methods: {
    getList: function () {
      this.$http.request(this.pageUrl, {filter: this.filter, page: this.pageInfo.current_page}).then(res => {
        if (!res) {
          return;
        }
        this.pageList = Array.isArray(res.data) ? res.data : [];
        if (res.meta) {
          this.pageInfo = {
            per_page: res.meta.per_page,
            current_page: res.meta.current_page,
            total: res.meta.total,
          };
        } else if (typeof res.per_page !== 'undefined') {
          // Laravel LengthAwarePaginator 直接在根字段返回分页信息（无外层 meta）
          this.pageInfo = {
            per_page: res.per_page,
            current_page: res.current_page,
            total: res.total,
          };
        }
      });
    },
    searchList: function () {
      this.pageInfo.current_page = 1;
      this.getList();
    },
    resetFilter: function () {
      this.filter = {keyword: "", status: ""};
      this.pageInfo.current_page = 1;
      this.getList();
    },
    changePage: function (page) {
      this.pageInfo.current_page = page;
      this.getList();
    },
    showAddDialog: function () {
      this.dialogTitle = "添加商户";
      this.form = {
        id: null,
        merchant_name: "",
        merchant_key: "",
        app_id: "",
        mch_id: "",
        key: "",
        cert_path: "",
        key_path: "",
        cost_fee_percent: 0.006,
        status: 1,
      };
      this.showDialog = true;
    },
    showEditDialog: function (row) {
      this.dialogTitle = "编辑商户";
      this.$http.request("getPayMerchant", {id: row.id}).then(res => {
        this.form = {
          id: res.data.id,
          merchant_name: res.data.merchant_name,
          merchant_key: res.data.merchant_key,
          app_id: res.data.app_id,
          mch_id: res.data.mch_id,
          key: res.data.key,
          cert_path: res.data.cert_path || "",
          key_path: res.data.key_path || "",
          cost_fee_percent: res.data.cost_fee_percent,
          status: res.data.status,
        };
        this.showDialog = true;
      });
    },
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          const url = this.form.id ? "updatePayMerchant" : "addPayMerchant";
          this.$http.request(url, this.form).then(res => {
            this.loading = false;
            if (res.status === "success") {
              this.showDialog = false;
              this.getList();
              this.$message({message: res.message, type: "success"});
            }
          }).catch(() => {
            this.loading = false;
          });
        }
      });
    },
    deleteMerchant: function (id) {
      this.$confirm("确定要删除该商户吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http.request("deletePayMerchant", {id: id}).then(res => {
          if (res.status === "success") {
            this.getList();
            this.$message({type: res.status, message: res.message});
          }
        });
      });
    },
    // 证书上传前校验
    beforeCertUpload: function (file) {
      const isPem = file.name.endsWith('.pem') || file.name.endsWith('.cert');
      if (!isPem) {
        this.$message.error('只能上传 .pem 或 .cert 格式的证书文件');
        return false;
      }
      if (!this.form.mch_id || !this.form.mch_id.trim()) {
        this.$message.error('请先填写微信商户号后再上传证书');
        return false;
      }
      this.certUploading = true;
      return true;
    },
    // 证书密钥上传前校验
    beforeCertKeyUpload: function (file) {
      const isPem = file.name.endsWith('.pem') || file.name.endsWith('.key');
      if (!isPem) {
        this.$message.error('只能上传 .pem 或 .key 格式的密钥文件');
        return false;
      }
      if (!this.form.mch_id || !this.form.mch_id.trim()) {
        this.$message.error('请先填写微信商户号后再上传证书密钥');
        return false;
      }
      this.certKeyUploading = true;
      return true;
    },
    // 证书上传成功
    handleCertSuccess: function (response, file, fileList) {
      this.certUploading = false;
      if (response.status === "success") {
        this.form.cert_path = response.data.path;
        this.$message.success('证书上传成功');
      } else {
        this.$message.error(response.message || '证书上传失败');
      }
    },
    // 证书上传失败
    handleCertError: function (err, file, fileList) {
      this.certUploading = false;
      this.$message.error('证书上传失败');
    },
    // 证书密钥上传成功
    handleCertKeySuccess: function (response, file, fileList) {
      this.certKeyUploading = false;
      if (response.status === "success") {
        this.form.key_path = response.data.path;
        this.$message.success('密钥上传成功');
      } else {
        this.$message.error(response.message || '密钥上传失败');
      }
    },
    // 证书密钥上传失败
    handleCertKeyError: function (err, file, fileList) {
      this.certKeyUploading = false;
      this.$message.error('密钥上传失败');
    },
  },
  created: function () {
    this.getList();
  },
  filters: {
    formatDateTime: function (value) {
      if (!value) return "-";
      const date = new Date(value);
      return date.toLocaleString("zh-CN", {year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit"});
    },
  },
};
</script>

<style scoped>
.search-bar {
  margin-bottom: 15px;
}

.操作区域 {
  margin-bottom: 15px;
}

.form-tips {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
  margin-top: 5px;
}

.cert-upload {
  display: inline-block;
}

.pay-merchant-table {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/settings/pay_merchant/list.vue